import { HTMLAttributes } from 'react'

import Container from '@/components/base/Container'
import Typography from '@/components/base/Typography'

import { cn } from '@/lib/utils'
import { WPPageData } from '@/types'

export type FreeTextCenteredProps = HTMLAttributes<HTMLElement> &
  Partial<{
    theme: WPPageData['acf']['theme']
    pretitle: string
    title: string
    content: string
  }>

const FreeTextCentered = ({
  theme = 'light',
  pretitle,
  title,
  content,
  className
}: FreeTextCenteredProps) => (
  <section
    className={cn(
      'text-center',
      theme === 'dark' ? 'bg-dark-600 text-white' : 'bg-white text-dark-500',
      className
    )}
  >
    <Container>
      <div className="mx-auto flex max-w-[67.4rem] flex-col items-center gap-[2.4rem]">
        {pretitle && (
          <Typography variant="label" className="font-extrabold">
            {pretitle}
          </Typography>
        )}
        {title && (
          <Typography component="h2" variant="h3">
            {title}
          </Typography>
        )}
        {content && (
          <Typography component="p" variant="body">
            {content}
          </Typography>
        )}
      </div>
    </Container>
  </section>
)

export default FreeTextCentered
